<template>
  <div class="site-top-band">
    <slot />
  </div>
</template>
<script>
export default { name: 'BannerComponent' }
</script>
